// extracted by mini-css-extract-plugin
module.exports = {"background":"PrivacyPolicy_background__1o66j","privacyContainer":"PrivacyPolicy_privacyContainer__PkCEx","font":"PrivacyPolicy_font__2-BdF"};